import type { Config } from './types';
import { env as baseEnv, type EnvKey } from '@skin-seoul/env-utils';

/**
 * Get environment variable at runtime
 * Safe to use on both server-side and client-side
 * @param key Environment variable key
 * @returns Environment variable value
 */
export const env = <T extends keyof Config>(key: T): string => baseEnv(key as EnvKey);

export { getGTMId } from './gtm';
export { getMediaOrigin, isClient, isDevOrStaging, isServer } from './env';
